import {combineReducers} from 'redux';
import mensagem from './MensagemReducer'
import protocolo from './ArmazenaProtocoloReducer'
import classificacoes from './classificacaoReducer'
import ufs from './ufReducer'
import endereco from './enderecoReducer'
import sas from './sasReducer'
import grupoTratamentoUFClassificacao from './grupoTratamentoReducerUFClassificacaoReducer'
import anexos from './anexosReducer'
import campanha from './campanhaReducer'
import navegacao from './ArmazenaNavegacaoReducer'
import atendimento from './atendimentoReducer'
import tipoPessoa from './tipoPessoaReducer'
import relatorioClassificacao from './relatorioClassificacaoReducer'
import relatorioClassificacaoPorAssunto from './relatorioClassificacaoPorAssuntoReducer'
import relatorioSituacao from './relatorioSituacaoReducer'
import relatorioParametros from './relatorioParametrosReducer'
import relatorioTempoRespostaFaixa from './relatorioTempoRespostaFaixaReducer'
import relatorioIndicadorTempoRespostaFaixa from './relatorioIndicadorTempoRespostaFaixaReducer'
import relatorioTempoRespostaClassificacaoFaixa from './relatorioTempoRespostaClassificacaoFaixaReducer'
import relatorioIndicadorNivelClassificacao from './relatorioIndicadorNivelClassificacaoReducer';
import relatorioAssuntoCassificacaoEstrutura from './relatorioAssuntoClassificacaoEstruturaReducer'
import relatorioTop5Assunto from './relatorioTop5AssuntoReducer'
import relatorioHierarquiaAssunto from './relatorioHierarquiaAssuntoReducer'
import relatorioHierarquiaAssuntoPorNatureza from './relatorioHierarquiaAssuntoPorNaturezaReducer'
import relatorioHierarquiaEstrutura from './relatorioHierarquiaEstruturaReducer'
import relatorioGeral from './relatorioGeralReducer'
import relatorioQuantitativoIntervaloAno from './relatorioQuantitativoIntervaloAnoReducer'


const rootReducer = combineReducers({
    mensagem,
    protocolo,
    classificacoes,
    ufs,
    endereco,
    sas,
    grupoTratamentoUFClassificacao,
    anexos,
    campanha,
    navegacao,
    atendimento,
    tipoPessoa,
    relatorioClassificacao,
    relatorioSituacao,
    relatorioParametros,
    relatorioTempoRespostaFaixa,
    relatorioIndicadorTempoRespostaFaixa,
    relatorioIndicadorNivelClassificacao,
    relatorioAssuntoCassificacaoEstrutura,
    relatorioTop5Assunto,
    relatorioQuantitativoIntervaloAno,
    relatorioHierarquiaAssunto,
    relatorioHierarquiaAssuntoPorNatureza,
    relatorioHierarquiaEstrutura,
    relatorioClassificacaoPorAssunto,
    relatorioTempoRespostaClassificacaoFaixa,
    relatorioGeral
});

export default rootReducer;


/** WEBPACK FOOTER **
 ** ./src/components/reduces/index.js
 **/